/**
 * Notificaciones in-app del usuario autenticado.
 * El bell del topbar hace polling de unread-count cada 30s.
 */
import { api } from "./client";

export type NotificationKind =
  | "trade_proposal"
  | "trade_accepted"
  | "trade_rejected"
  | "trade_completed"
  | "message"
  | "match"
  | "review"
  | string;

export interface Notification {
  id: number;
  kind: NotificationKind;
  title: string;
  body: string | null;
  payload: Record<string, unknown> | null;
  read_at: string | null;
  created_at: string;
}

export async function fetchNotifications(opts: { limit?: number; only_unread?: boolean } = {}): Promise<Notification[]> {
  const params = new URLSearchParams();
  if (opts.limit) params.set("limit", String(opts.limit));
  if (opts.only_unread) params.set("only_unread", "true");
  const qs = params.toString();
  return api<Notification[]>(`/notifications/me${qs ? "?" + qs : ""}`);
}

export async function fetchUnreadCount(): Promise<number> {
  const res = await api<{ unread: number }>("/notifications/me/unread-count");
  return res.unread;
}

export async function markRead(notifId: number): Promise<Notification> {
  return api<Notification>(`/notifications/${notifId}/read`, { method: "POST" });
}

export async function markAllRead(): Promise<{ marked: number }> {
  return api<{ marked: number }>("/notifications/me/read-all", { method: "POST" });
}
